import { NavLink } from 'react-router';

import { cn } from '@/shared/lib/cn';
import { KairoLogo } from '@/shared/ui/KairoLogo';

import { MORE_SECTIONS, type NavSection, PRIMARY_SECTIONS } from './sections';

/** На компьютере «Ещё» не нужен: всё, что в нём, уже стоит в меню. */
const MAIN = PRIMARY_SECTIONS.filter((section) => section.to !== '/more');

/**
 * Боковое меню версии для компьютера.
 *
 * Приложение одно и подстраивается под экран: на телефоне — нижняя панель из
 * пяти вкладок, на широком экране (от 1024 px) — меню слева со всеми
 * разделами сразу. Места хватает, и прятать половину разделов в «Ещё» незачем.
 */
export function SideNav() {
  return (
    <aside className="fixed inset-y-0 left-0 z-40 hidden w-[var(--side-nav-width)] flex-col border-r border-border bg-surface lg:flex">
      <div className="flex items-center gap-2.5 px-5 pt-6 pb-5">
        <KairoLogo size={32} />
        <span className="text-[18px] font-bold tracking-tight">Kairo</span>
      </div>

      <nav aria-label="Разделы" className="flex-1 overflow-y-auto px-3 pb-6">
        <SectionList sections={MAIN} />
        <p className="mt-6 mb-2 px-3 text-[11px] font-semibold tracking-wider text-subtle uppercase">
          Ещё
        </p>
        <SectionList sections={MORE_SECTIONS} />
      </nav>
    </aside>
  );
}

function SectionList({ sections }: { sections: NavSection[] }) {
  return (
    <ul className="space-y-0.5">
      {sections.map((section) => (
        <li key={section.to}>
          <NavLink
            to={section.to}
            // «Профиль» не должен гореть на «Режиме дня»: у них общий префикс.
            end={section.to === '/profile'}
            className={({ isActive }) =>
              cn(
                'flex h-10 items-center gap-3 rounded-md px-3 text-[14px] font-medium',
                'transition-colors duration-150',
                isActive
                  ? 'bg-brand-soft text-brand-soft-text'
                  : 'text-muted hover:bg-surface-2 hover:text-content',
              )
            }
          >
            <section.icon size={18} aria-hidden className="shrink-0" />
            <span className="truncate">{section.label}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  );
}
